import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';

import Nav from './components/Nav';
import Landing from './components/Landing';
import Mechventilatie from './components/Mechventilatie';
import WTWsystemen from './components/WTWsystemen';
import Dakventilatie from './components/Dakventilatie';
import Tarieven from './components/Tarieven';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import './styles/global.scss';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Nav />
      <div className="App">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/Home" element={<Landing />} />
          <Route path="/Mechanische-ventilatie" element={<Mechventilatie />} />
          <Route path="/WTW-systemen" element={<WTWsystemen />} />
          <Route path="/Dakventilatie" element={<Dakventilatie />} />
          <Route path="/Tarieven" element={<Tarieven />} />
          <Route path="/Contact" element={<Contact />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
